import * as React from 'react';

export const DELETE_ACTIVITY_MODAL_TEXTS = {
  CONFIRMATION: <>Вы&nbsp;уверены, что хотите удалить комментарий?</>,
  NON_CANCELABLE: <>Действие нельзя будет отменить.</>,
  DELETE_COMMENT: <>Удалить комментарий</>,
};
